import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import validarAlvaraSelector from "../store/alvara.selectors";
import validarAlvaraActions from "../store/alvara.actions";
import { ddadosValidarAlvara as DDados } from "../alvara.ddados";
import Form from "@common/externos/components/validation/form.validation";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      blockDoubleClick: true,
      isImprimir: false
    }
  }

  componentDidMount() {
    const values = this.props.routerManager.params;

    if (values.validarDireto) {
      let dto = {
        NumeroProjeto: values.numeroProjeto,
        AnoProjeto: values.anoProjeto,
        NumeroAlvara: values.numeroAlvara,
        EmissaoAlvara: values.emissaoAlvara
      };

      this.props.validarAlvaraActions.setAlvara(dto);
      this.props.validarAlvaraActions.validarAlvara(dto);
    }
  }

  get initialValues() {
    return {};
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "obrasParticulares" });
  }

  async onValidate(item) {
    this.props.validarAlvaraActions.validarAlvara(item);
  }

  async onPrintReport(data) {
    this.props.validarAlvaraActions.imprimirAlvara(data);
  }

  render() {
    const { Campos } = DDados;
    const { prefix, form, disableAll, isView } = this.props;
    const { alvara } = this.props.validarAlvaraSelector;
    const { isImprimir, blockDoubleClick } = this.state;
    const Titulo = (isImprimir ? "Imprimir" : "Validar") + " Alvará";

    return (
      <Form
        onValidate={!isImprimir ? this.onValidate : null}
        onPrintReport={isImprimir? this.onPrintReport : null}
        onCancel={this.onCancel}
        boxForm
        initialValues={this.initialValues}
        prefix={prefix}
        title={Titulo}
        formControl={true}
      >
          {form => (
      <Fragment>
        <Row>
          <Col lg={"4"}>
            <DDadosItem name="NumeroProjeto" {...Campos.NumeroProjeto}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="AnoProjeto" {...Campos.AnoProjeto}  state={alvara}/>
          </Col>
          </Row>
          <Row>
          <Col lg={"4"}>
            <DDadosItem name="NumeroAlvara" {...Campos.NumeroAlvara}  state={alvara}/>
          </Col>
          <Col lg={"4"}>
            <DDadosItem name="EmissaoAlvara" {...Campos.EmissaoAlvara}  state={alvara}/>
          </Col>
          </Row>
          </Fragment>
        )}
      </Form>
    );
  }
}

export default connect({
  actions: {
    validarAlvaraActions
  },
  selectors: {
    validarAlvaraSelector
  }
})(Container);
